import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import api from '../utils/api';
import { isMobileContainer } from '../utils/device';
import { getPostLoginPath } from '../utils/rolePaths';

const SsoCallback = () => {
  const [searchParams] = useSearchParams();
  const code = searchParams.get('code');
  const navigate = useNavigate();
  const { applyAcademySsoSession } = useAuth();
  const [message, setMessage] = useState('Signing you in…');

  useEffect(() => {
    let cancelled = false;
    let timeoutId;

    (async () => {
      if (!code) {
        navigate('/login?sso=missing', { replace: true });
        return;
      }

      try {
        const ssoBody = isMobileContainer() ? { code, client: 'mobile' } : { code };
        const res = await api.post('/auth/academy-sso', ssoBody);
        if (cancelled) return;

        const body = res.data;
        const data = body?.data ?? body;
        const token = data?.token;
        const user = data?.user;

        if (!token || !user) {
          throw new Error(body?.message || 'SSO exchange failed');
        }

        await applyAcademySsoSession({ token, user });
        navigate(getPostLoginPath(user?.role_slug, user), { replace: true });
      } catch (e) {
        if (cancelled) return;
        const msg = e?.response?.data?.message || e?.message || 'SSO failed';
        setMessage(msg);
        const encoded = encodeURIComponent(msg);
        timeoutId = setTimeout(() => navigate(`/login?sso=error&sso_msg=${encoded}`, { replace: true }), 2000);
      }
    })();

    return () => {
      cancelled = true;
      clearTimeout(timeoutId);
    };
  }, [code, navigate, applyAcademySsoSession]);

  return (
    <div className="min-h-screen bg-background flex flex-col items-center justify-center gap-4 text-foreground">
      <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500" />
      <p className="text-sm">{message}</p>
    </div>
  );
};

export default SsoCallback;
